<template>
  <div>

    <div v-html="html"></div>

    <template v-if="found === false">
      <h3>Page non trouvée</h3>
    </template>

  </div>
</template>

<script>
  export default {
    name: 'page-generique-html',
    props: {
      path: {
        type: String
      }
    },
    data() {
      return {
        html: null,
        found: null
      };
    },
    async mounted() {
      const data = await fetch(this.path);
      if (data.ok) {
        this.html = await data.text();
      }
      else {
        this.found = false;
      }
    }
  };
</script>

<style scoped>

</style>
